export default __webpack_public_path__ + "static/1- switch to map view-9bd29e3d0bfe9007482546bd2b196cff.gif";